/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequestErrorDto,
  ConflictErrorDto,
  InternalErrorDto,
  NotFoundErrorDto,
  OrderInfoDto,
  PreorderBookingDetailsInfoResponseDto,
  PreorderSummaryResponseDto,
  SubmitOrderBookingInfoRequestDto,
  SubmitPersonalInfoRequestDto,
  SubmitPersonalInfoResponseDto,
} from '../models/index';
import {
    BadRequestErrorDtoFromJSON,
    BadRequestErrorDtoToJSON,
    ConflictErrorDtoFromJSON,
    ConflictErrorDtoToJSON,
    InternalErrorDtoFromJSON,
    InternalErrorDtoToJSON,
    NotFoundErrorDtoFromJSON,
    NotFoundErrorDtoToJSON,
    OrderInfoDtoFromJSON,
    OrderInfoDtoToJSON,
    PreorderBookingDetailsInfoResponseDtoFromJSON,
    PreorderBookingDetailsInfoResponseDtoToJSON,
    PreorderSummaryResponseDtoFromJSON,
    PreorderSummaryResponseDtoToJSON,
    SubmitOrderBookingInfoRequestDtoFromJSON,
    SubmitOrderBookingInfoRequestDtoToJSON,
    SubmitPersonalInfoRequestDtoFromJSON,
    SubmitPersonalInfoRequestDtoToJSON,
    SubmitPersonalInfoResponseDtoFromJSON,
    SubmitPersonalInfoResponseDtoToJSON,
} from '../models/index';

export interface CancelOrderRequest {
    number: string;
}

export interface GetInfoForBookingRequest {
    adults: number;
    arrivalDate: string;
    departureDate: string;
    ratePlanId: string;
    propertyId: string;
    roomTypeId: string;
    checksum: string;
    childAges?: Array<number>;
}

export interface GetOrderByOrderNumberRequest {
    orderNumber: string;
}

export interface GetPreorderSummaryRequest {
    propertyId: string;
    roomTypeId: string;
}

export interface SubmitBookingInfoRequest {
    submitOrderBookingInfoRequestDto: SubmitOrderBookingInfoRequestDto;
}

export interface SubmitPersonalInfoRequest {
    submitPersonalInfoRequestDto: SubmitPersonalInfoRequestDto;
}

/**
 * 
 */
export class OrdersApi extends runtime.BaseAPI {

    /**
     * Cancel booking by number
     * Cancel booking by number
     */
    async cancelOrderRaw(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling cancelOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/{number}/cancel`.replace(`{${"number"}}`, encodeURIComponent(String(requestParameters['number']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Cancel booking by number
     * Cancel booking by number
     */
    async cancelOrder(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.cancelOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Предоставляет информацию о предзаказе по указанным фильтрам
     * Получение информации для предзаказа
     */
    async getInfoForBookingRaw(requestParameters: GetInfoForBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreorderBookingDetailsInfoResponseDto>> {
        if (requestParameters['adults'] == null) {
            throw new runtime.RequiredError(
                'adults',
                'Required parameter "adults" was null or undefined when calling getInfoForBooking().'
            );
        }

        if (requestParameters['arrivalDate'] == null) {
            throw new runtime.RequiredError(
                'arrivalDate',
                'Required parameter "arrivalDate" was null or undefined when calling getInfoForBooking().'
            );
        }

        if (requestParameters['departureDate'] == null) {
            throw new runtime.RequiredError(
                'departureDate',
                'Required parameter "departureDate" was null or undefined when calling getInfoForBooking().'
            );
        }

        if (requestParameters['ratePlanId'] == null) {
            throw new runtime.RequiredError(
                'ratePlanId',
                'Required parameter "ratePlanId" was null or undefined when calling getInfoForBooking().'
            );
        }

        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling getInfoForBooking().'
            );
        }

        if (requestParameters['roomTypeId'] == null) {
            throw new runtime.RequiredError(
                'roomTypeId',
                'Required parameter "roomTypeId" was null or undefined when calling getInfoForBooking().'
            );
        }

        if (requestParameters['checksum'] == null) {
            throw new runtime.RequiredError(
                'checksum',
                'Required parameter "checksum" was null or undefined when calling getInfoForBooking().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['adults'] != null) {
            queryParameters['adults'] = requestParameters['adults'];
        }

        if (requestParameters['arrivalDate'] != null) {
            queryParameters['arrivalDate'] = requestParameters['arrivalDate'];
        }

        if (requestParameters['departureDate'] != null) {
            queryParameters['departureDate'] = requestParameters['departureDate'];
        }

        if (requestParameters['ratePlanId'] != null) {
            queryParameters['ratePlanId'] = requestParameters['ratePlanId'];
        }

        if (requestParameters['propertyId'] != null) {
            queryParameters['propertyId'] = requestParameters['propertyId'];
        }

        if (requestParameters['roomTypeId'] != null) {
            queryParameters['roomTypeId'] = requestParameters['roomTypeId'];
        }

        if (requestParameters['checksum'] != null) {
            queryParameters['checksum'] = requestParameters['checksum'];
        }

        if (requestParameters['childAges'] != null) {
            queryParameters['childAges'] = requestParameters['childAges']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/bookingInfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreorderBookingDetailsInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Предоставляет информацию о предзаказе по указанным фильтрам
     * Получение информации для предзаказа
     */
    async getInfoForBooking(requestParameters: GetInfoForBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreorderBookingDetailsInfoResponseDto> {
        const response = await this.getInfoForBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed info about order by order number
     * Get order by order number
     */
    async getOrderByOrderNumberRaw(requestParameters: GetOrderByOrderNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderInfoDto>> {
        if (requestParameters['orderNumber'] == null) {
            throw new runtime.RequiredError(
                'orderNumber',
                'Required parameter "orderNumber" was null or undefined when calling getOrderByOrderNumber().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderNumber'] != null) {
            queryParameters['orderNumber'] = requestParameters['orderNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderInfoDtoFromJSON(jsonValue));
    }

    /**
     * Get detailed info about order by order number
     * Get order by order number
     */
    async getOrderByOrderNumber(requestParameters: GetOrderByOrderNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderInfoDto> {
        const response = await this.getOrderByOrderNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Предоставляет краткую сводную информацию об объекте размещения и номере для предзаказа по указанным фильтрам
     * Получение краткой информации для предзаказа (сводка)
     */
    async getPreorderSummaryRaw(requestParameters: GetPreorderSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreorderSummaryResponseDto>> {
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling getPreorderSummary().'
            );
        }

        if (requestParameters['roomTypeId'] == null) {
            throw new runtime.RequiredError(
                'roomTypeId',
                'Required parameter "roomTypeId" was null or undefined when calling getPreorderSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['propertyId'] != null) {
            queryParameters['propertyId'] = requestParameters['propertyId'];
        }

        if (requestParameters['roomTypeId'] != null) {
            queryParameters['roomTypeId'] = requestParameters['roomTypeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/preorder-summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreorderSummaryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Предоставляет краткую сводную информацию об объекте размещения и номере для предзаказа по указанным фильтрам
     * Получение краткой информации для предзаказа (сводка)
     */
    async getPreorderSummary(requestParameters: GetPreorderSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreorderSummaryResponseDto> {
        const response = await this.getPreorderSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Endpoint to submit booking details information
     * Submit booking information
     */
    async submitBookingInfoRaw(requestParameters: SubmitBookingInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['submitOrderBookingInfoRequestDto'] == null) {
            throw new runtime.RequiredError(
                'submitOrderBookingInfoRequestDto',
                'Required parameter "submitOrderBookingInfoRequestDto" was null or undefined when calling submitBookingInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/bookingInfo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitOrderBookingInfoRequestDtoToJSON(requestParameters['submitOrderBookingInfoRequestDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Endpoint to submit booking details information
     * Submit booking information
     */
    async submitBookingInfo(requestParameters: SubmitBookingInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.submitBookingInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Endpoint to submit user and guest personal details
     * Submit user personal details
     */
    async submitPersonalInfoRaw(requestParameters: SubmitPersonalInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitPersonalInfoResponseDto>> {
        if (requestParameters['submitPersonalInfoRequestDto'] == null) {
            throw new runtime.RequiredError(
                'submitPersonalInfoRequestDto',
                'Required parameter "submitPersonalInfoRequestDto" was null or undefined when calling submitPersonalInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/personalInfo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitPersonalInfoRequestDtoToJSON(requestParameters['submitPersonalInfoRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmitPersonalInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Endpoint to submit user and guest personal details
     * Submit user personal details
     */
    async submitPersonalInfo(requestParameters: SubmitPersonalInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitPersonalInfoResponseDto> {
        const response = await this.submitPersonalInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
